// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LatestNews: React.FC = () => {
    return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 55 62" enableBackground="new 0 0 55 62" xmlSpace="preserve">
   <defs>
       <filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="0" y="0" width="55" height="61.96">
           <feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
       </filter>
   </defs>  
   <path id="tab" fillRule="evenodd" clipRule="evenodd" fill="#158F7A" d="M40.29,0H14.71H0v47.25
       c0,8.13,6.59,14.71,14.71,14.71h25.57c8.13,0,14.71-6.59,14.71-14.71V0H40.29z"/>
   <path id="shadow" fill="#0D463C" d="M55,47.25V34.23L40.43,12.6c-0.69-1.64-2.61-2.07-4.49-2.07h-16.2c-2.51,0-4.56,2.05-4.56,4.56
       v24.24c0,1.58-0.13,3.23,1.1,4.05c0.3,0.39,19.94,17.75,20.88,18.58h3.13C48.41,61.96,55,55.37,55,47.25z"/>
   <defs>
       <filter id="Adobe_OpacityMaskFilter_1_" filterUnits="userSpaceOnUse" x="15.18" y="10.53" width="25.32" height="33.36">
           <feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
       </filter>
   </defs>   
   <path id="paper" fillRule="evenodd" clipRule="evenodd" fill="#FEFEFE" d="M29.7,25.17h7.5V15.8h-7.5
       V25.17z M18.48,28.89H37.2v-1.91H18.48V28.89z M18.48,32.62H37.2V30.7H18.48V32.62z M18.48,36.34H37.2v-1.91H18.48V36.34z
        M18.48,25.17h9.36v-1.91h-9.36V25.17z M18.48,21.44h9.36v-1.91h-9.36V21.44z M18.48,17.72h9.36V15.8h-9.36V17.72z M37.84,10.53
       H17.84c-1.46,0-2.66,1.2-2.66,2.66v28.05c0,1.46,1.2,2.66,2.66,2.66h20.01c1.46,0,2.66-1.2,2.66-2.66V13.19
       C40.5,11.72,39.3,10.53,37.84,10.53L37.84,10.53z"/>
   </svg>
    );
};


export default React.memo(LatestNews);


